// extracted by mini-css-extract-plugin
export default {"devloper":"Developer_devloper__MSJfE","top_dev":"Developer_top_dev__rhtVt","seeall":"Developer_seeall__wpDGE"};